module.exports = __webpack_public_path__ + "img/MDI-paperclip.631ad07a.svg";